import React from 'react';

function UserStats() {
  return (
    <div>UserStats</div>
  )
}

export default UserStats;